// @flow
import type { AppState } from 'modules/rootReducer';
import type { GalleryImageType } from 'types/common';
import type { Countries, ProjectDetails } from 'types/project';
import { filter } from 'lodash';
import { ProjectMapper } from 'mappers/project';
import type { VersionType } from 'types/product';
import { ProductBrowserSelector } from 'modules/productBrowser/selector';
import { ProjectBrowserSelector } from 'modules/projectBrowser/selector';
import { HomeSelector } from 'modules/home/selector';
import { ProjectSelector } from 'modules/project/selector';
import { LocationSelector } from 'modules/location/selector';

const getGallery = (state: AppState): Array<GalleryImageType> | null => {
  return state.product.gallery;
};

const getGalleryLoading = (state: AppState): boolean => {
  return state.product.loading.gallery;
};

const getGalleryError = (state: AppState): string | null => {
  return state.product.error.gallery;
};

const getProjects = (state: AppState): Object<ProjectDetails> | null => {
  const projectDetails = state.project.projects;
  const productDetail = state.productBrowser.productDetails;
  let data = {};
  if (projectDetails && productDetail) {
    const id = productDetail.productDetails[0].id;
    const countries: Object<Countries> = {};
    data.list = filter(projectDetails.list, {
      products: [{ id: id }],
    });
    data.list.map(project => {
      ProjectMapper.getProjectCountInCountry(
        project.countryId,
        project.country,
        countries
      );
      data.countries = countries;
    });
  }
  return projectDetails ? data : null;
};

const getProjectLoading = (state: AppState): boolean => {
  return state.project.loading.projects;
};

const getProjectError = (state: AppState): string | null => {
  return state.project.error.projects;
};

const getProjectsForArchitects = (
  state: AppState
): Object<ProjectDetails> | null => {
  const projectDetails = state.project.projects;
  let data = {};
  if (projectDetails) {
    const countries: Object<Countries> = {};
    data.list = projectDetails.list;
    data &&
      data.list &&
      data.list.map(project => {
        ProjectMapper.getProjectCountInCountry(
          project.countryId,
          project.country,
          countries
        );
        data.countries = countries;
      });
  }
  return projectDetails ? data : null;
};

const getVersions = (state: AppState): Array<VersionType> | null => {
  return state.product.versions;
};

const getVersionLoading = (state: AppState): boolean => {
  return state.product.loading.versions;
};

const getVersionError = (state: AppState): string | null => {
  return state.product.error.versions;
};

const isLoading = (state: AppState) => {
  return (
    ProductBrowserSelector.isLoading(state) ||
    HomeSelector.getVerticalsLoading(state) ||
    HomeSelector.getSiteSettingsLoading(state) ||
    HomeSelector.getContactsLoading(state) ||
    ProjectSelector.getProjectLoading(state) ||
    getGalleryLoading(state) ||
    getVersionLoading(state) ||
    LocationSelector.getUserLocationLoading(state)
  );
};
export const ProductSelector = {
  getGallery,
  getGalleryLoading,
  getGalleryError,
  getProjects,
  getProjectLoading,
  getProjectError,
  getVersions,
  getVersionLoading,
  getVersionError,
  isLoading,
  getProjectsForArchitects,
};
